import LoginComponent from "../../components/Login";

export default function Login() {
  return <LoginComponent />;
}
